import request from '@/utils/request'
import { getRequest } from "@/utils/postData";

// 获取tdk
export function getTdkList(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/homeTdk/list',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}

// 获取公示
export function getPublicity(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/publicity/list',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}

// 获取内联字
export function getLinks(params) {
    var sign = getRequest(params);
    return request({
        url: '/v4/externalLink/list',
        method: 'get',
        params,
        headers: {
            'X-Signature': sign
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/tdk.js